import React from "react";
import { BsDatabaseFillDown } from "react-icons/bs";
import { PiChartLineDownBold } from "react-icons/pi";

const DataMasuk = ({ total, bulan, name, icon }) => {
  return (
    <>
      <div className="flex flex-col gap-2 rounded-[10px] bg-gradient-to-b from-gray-800 to-sky-800 p-4">
        <div className="flex items-center justify-between gap-2 rounded-full">
          <BsDatabaseFillDown size={20} color="white" />
          <h4 className="mb-1.5 text-heading-6 font-bold text-white">
            {bulan}
          </h4>
        </div>
        <div>
          <div className="flex items-center justify-between gap-2">
            <h4 className="text-2xl font-bold text-white text-inline">
              {Intl.NumberFormat("id-ID").format(total)}
            </h4>
            <span className="p-1 rounded-full bg-white">
              {icon}
            </span>
          </div>
          <span className="text-body-sm font-medium text-gray-300">
            {name}
          </span>
        </div>
      </div>
    </>
  );
};

export default DataMasuk;
